/* tslint:disable */

// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export var ApplicationNameEnum = /*#__PURE__*/function (ApplicationNameEnum) {
  ApplicationNameEnum["LEARNING"] = "LEARNING";
  ApplicationNameEnum["TALENT"] = "TALENT";
  return ApplicationNameEnum;
}({});
export var ApplicationRoleEnum = /*#__PURE__*/function (ApplicationRoleEnum) {
  ApplicationRoleEnum["ROLE_ADMIN"] = "ROLE_ADMIN";
  ApplicationRoleEnum["ROLE_USER"] = "ROLE_USER";
  return ApplicationRoleEnum;
}({});
export var ConfigurationAdminEnum = /*#__PURE__*/function (ConfigurationAdminEnum) {
  ConfigurationAdminEnum["ACTIVE"] = "ACTIVE";
  ConfigurationAdminEnum["DISABLED"] = "DISABLED";
  ConfigurationAdminEnum["INACTIVE"] = "INACTIVE";
  return ConfigurationAdminEnum;
}({});
export var FeatureFlagCategoryEnum = /*#__PURE__*/function (FeatureFlagCategoryEnum) {
  FeatureFlagCategoryEnum["CATEGORY_EXPERIMENTAL"] = "CATEGORY_EXPERIMENTAL";
  FeatureFlagCategoryEnum["CATEGORY_FEATURE"] = "CATEGORY_FEATURE";
  return FeatureFlagCategoryEnum;
}({});
export var UserOrganizationRoleEnum = /*#__PURE__*/function (UserOrganizationRoleEnum) {
  UserOrganizationRoleEnum["ADMIN"] = "ADMIN";
  UserOrganizationRoleEnum["LEADER"] = "LEADER";
  UserOrganizationRoleEnum["MEMBER"] = "MEMBER";
  UserOrganizationRoleEnum["SUBADMIN"] = "SUBADMIN";
  return UserOrganizationRoleEnum;
}({});

//==============================================================
// END Enums and Input Objects
//==============================================================